export const GET_ADO_PROJECTS_REQUEST = 'GET_ADO_PROJECTS_REQUEST';
export const GET_ADO_PROJECTS_SUCCESS = 'GET_ADO_PROJECTS_SUCCESS';
export const GET_ADO_PROJECTS_FAILURE = 'GET_ADO_PROJECTS_FAILURE';

export const GET_ALL_WORKITEMS_ID_REQUEST = 'GET_ALL_WORKITEMS_ID_REQUEST';
export const GET_ALL_WORKITEMS_ID_SUCCESS = 'GET_ALL_WORKITEMS_ID_SUCCESS';
export const GET_ALL_WORKITEMS_ID_FAILURE = 'GET_ALL_WORKITEMS_ID_FAILURE';

export const GET_ALL_WORKITEMS_DETAILS_REQUEST =
  'GET_ALL_WORKITEMS_DETAILS_REQUEST';
export const GET_ALL_WORKITEMS_DETAILS_SUCCESS =
  'GET_ALL_WORKITEMS_DETAILS_SUCCESS';
export const GET_ALL_WORKITEMS_DETAILS_FAILURE =
  'GET_ALL_WORKITEMS_DETAILS_FAILURE';

export const GET_PROJECT_WORKITEMS = 'GET_PROJECT_WORKITEMS';

export const SET_ADO_TEXT_FILTER = 'SET_ADO_TEXT_FILTER';
export const SET_ADO_ASSIGNEDTO_FILTER = 'SET_ADO_ASSIGNEDTO_FILTER';
export const SET_ADO_STATE_FILTER = 'SET_ADO_STATE_FILTER';
